import { useAxiosRequest } from "api/axiosRequest";
import { BASE_URL } from "api/url_helper";

interface StartBacktestResponse {
  imo: string,
  success: boolean,
  error: string
}

export function usePortPredictorBacktestAPI() {
  const request = useAxiosRequest()

  async function startBacktest() {
    try {
      await request<any, StartBacktestResponse>({
        url: `${BASE_URL}/port-predictor/backtest`,
      })
    } catch (err) {
      console.error("Error starting backtest", err)
      throw new Error("Failed to start backtest")
    }
  }

  return {
    startBacktest
  }
}